import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Card, Col, Container, Row, Form, Button } from "reactstrap";
import { useSetRecoilState } from "recoil";
import { termAllAgree } from "../../states/recoilState";
import "../Authentication/lineupmodal.scss";
import { useTranslation } from "react-i18next";

const TermAgreement = ({ termAgreement, setTermAgreement }) => {
  const { t:translate, i18n } = useTranslation();

  const setTermAllAgreeInfo = useSetRecoilState(termAllAgree);

  useEffect(() => {
    document.body.style.cssText = `
      position: fixed; 
      top: -${window.scrollY}px;
      width: 100%;`;
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.cssText = "";
      window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
    };
  }, []);

  const closeXModal = (e) => {
    setTermAgreement(!termAgreement);
    setTermAllAgreeInfo({
      agree: false
    });
  };

  const onAllAgreement = async (e) => {
    e.preventDefault();
    if(allCheck === false) {
      alert("전체 동의해야 회원 가입이 가능합니다.");
    }  
    else{
      setTermAllAgreeInfo({ agree: "true" });//이용 약관 동의여부 true
      setTermAgreement(!termAgreement);
    }

  };

  // 약관동의 체크박스 관련 - add 2023-04-26, ykw
  const [allCheck, setAllCheck] = useState(false);
  const [termCheck, setTermCheck] = useState(false);
  const [pInfoCheck, setPInfoCheck] = useState(false);

  const allBtnEvent =()=>{
    if(allCheck === false) {
      setAllCheck(true);
      setTermCheck(true);
      setPInfoCheck(true);
    }else {
      setAllCheck(false);
      setTermCheck(false);
      setPInfoCheck(false);
    } 
  };
  
  const termBtnEvent =()=>{
    if(termCheck === false) {
      setTermCheck(true)
    }else {
      setTermCheck(false)
    }
  };
  
  const pInfoBtnEvent =()=>{
    if(pInfoCheck === false) {
      setPInfoCheck(true)
    }else {
      setPInfoCheck(false)
    }
  };

  useEffect(()=>{
    if(termCheck===true && pInfoCheck===true){
      setAllCheck(true)
    } else {
      setAllCheck(false)
    }
  }, [termCheck,pInfoCheck])

  return (
    <React.Fragment>
      <Container fluid className="modalWrap">
        <Row className="w-100 h-100 m-0 p-0 d-flex align-items-center justify-content-center">
          <Col>
            <Form
              style={{ display: "flex", justifyContent: "center" }}
              onSubmit={onAllAgreement}
            >
              <div className="modalOverlay" />
              <Card className="modalCard">
                <Row className="w-100" style={{ margin: "0px 0px 15px 0px" }}>
                  <Col
                    style={{
                      fontSize: "24px",
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    {translate('terms_agreement_title')}
                  </Col>
                  </Row>
                  {/* <Row className="w-100" style={{ margin: "0px 0px 22px 0px" }}>
                    <Col style={{ fontSize: "17px", fontWeight: "300" }}>
                      회원 가입을 위해서는 이용 약관 및 개인정보 이용 동의가 필요합니다.
                      아래 내용을 읽어보고, 동의해 주시기 바랍니다.
                    </Col>
                  </Row> */}
                  
                  <Row className="w-100" style={{ margin: "0px 0px 20px 0px" }}>
                    
                  </Row>
                  <Row className="w-100 m-0">
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "6px",
                    }}
                    >
                    <input
                      type="checkbox"
                      style={{
                        width: "18px",
                        height: "19px",
                        marginRight: "10px",
                      }}
                      checked={termCheck} onChange={termBtnEvent}
                    />
                    <span>{translate('terms_agreement_subtitle_1')}</span>
                  </div>
                  </Row>

                  <Row className="w-100 m-0">
                  <div
                  style={{
                    width: "400px",
                    height: "200px",
                    overflow: "auto", 
                    border: "1px solid black",
                    padding: "0 0.5em",
                    fontSize: "12px",
                  }}
                  >
                   <p>{translate('terms_agreement_version_date')}</p>
                   <p>
                   {translate('terms_agreement_text_1')}
                  </p>
                  <p>
                   {translate('terms_agreement_text_2')}
                  </p>
                  <p>
                   {translate('terms_agreement_text_3')}
                  </p>
                </div>
                </Row>

                <Row className="w-100 m-0">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "6px",
                    marginTop: "6px",
                  }}
                  >
                  <input
                    type="checkbox"
                    style={{
                      width: "18px",
                      height: "19px",
                      marginRight: "10px",
                    }}
                    checked={pInfoCheck} onChange={pInfoBtnEvent}
                  />
                  <span>{translate('terms_agreement_subtitle_2')}</span>
                  </div>
                </Row>
                <Row className="w-100 m-0">
                <div
                style={{
                  width: "400px",
                  height: "200px",
                  overflow: "auto", 
                  border: "1px solid black",
                  padding: "0 0.5em",
                  marginBottom: "6px",
                  fontSize: "12px",
                }}
                >
                  <p>
                    {translate('terms_agreement_text_4')}
                  </p>
                  <p>
                    {translate('terms_agreement_text_5')}
                   </p>
                   <p>
                    {translate('terms_agreement_text_6')} 
                  </p>

                </div>
                </Row>

                <Row className="w-100 m-0">
                  <Col className="d-flex justify-content-between">
                  <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "6px",
                  }}
                  >
                  <input
                    type="checkbox"
                    style={{
                      width: "18px",
                      height: "19px",
                      marginRight: "10px",
                    }}
                    checked={allCheck} onChange={allBtnEvent}
                  />
                  <span>{translate('total_confirm')}</span>
                  </div>
                  </Col>
                </Row>

                <Row className="w-100 row p-0 m-20">
                  <Col className="d-flex justify-content-center">
                    <Button
                      style={{
                        border: "none",
                        backgroundColor: "#A7A7A7",
                        borderRadius: "8px",
                        padding: "15px 40px",
                        // float: "right",
                        color: "#000",
                      }}
                      onClick={() => closeXModal()}
                    >
                      {translate('cancel')}
                    </Button>

                    <Button
                      style={{
                        border: "none",
                        backgroundColor: "#3EA6FF",
                        borderRadius: "8px",
                        padding: "15px 40px",
                        color: "#fff",
                        fontWeight: "600",
                        // float: "right",
                        margin: "0px 0px 0px 5px"
                      }}
                      type="submit"
                    >
                      {translate('confirm')}
                    </Button>

                  </Col>
                </Row>
              </Card>
            </Form>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default withRouter(TermAgreement);
